import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuth } from "@/infra/auth/AuthProvider";
import { HOME_PATH } from "@/components/shell/nav";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Oxley · Products and packaging in one place" },
      { name: "description", content: "Design packages, get approvals and publish to your sales tools." },
      { property: "og:title", content: "Oxley · Products and packaging in one place" },
      { property: "og:description", content: "Guided steps, an assistant that suggests, and built-in packaging rules that check every change." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: Landing,
});

function Landing() {
  const { claims, ready } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (!ready) return;
    if (!claims) {
      navigate({ to: "/auth", replace: true });
      return;
    }
    navigate({ to: HOME_PATH, replace: true });
  }, [ready, claims, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background" aria-live="polite">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-border border-t-primary" aria-label="Opening Oxley" />
    </div>
  );
}
